import { render } from "./SkelTable.vue?vue&type=template&id=5a53e99a&scoped=true"
import script from "./SkelTable.vue?vue&type=script&lang=js"
export * from "./SkelTable.vue?vue&type=script&lang=js"

import "./SkelTable.vue?vue&type=style&index=0&id=5a53e99a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a53e99a"]])

export default __exports__